export default __webpack_public_path__ + "static/media/10.54d9ecd6.png";